import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCnFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53074)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1383 41.3792H0.862596C0.386523 41.3792 0.000488281 40.9932 0.000488281 40.5171V9.48271C0.000488281 9.00664 0.386523 8.62061 0.862596 8.62061H49.1384C49.6145 8.62061 50.0005 9.00664 50.0005 9.48271V40.5171C50.0004 40.9933 49.6144 41.3792 49.1383 41.3792Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.30118 13.7433L9.12305 16.2075L11.7207 16.2276C12.057 16.2302 12.1965 16.6595 11.9259 16.8592L9.83623 18.4022L10.6197 20.879C10.7211 21.1997 10.3561 21.4648 10.0824 21.2693L7.96915 19.7587L5.85587 21.2692C5.58224 21.4648 5.2172 21.1995 5.31857 20.8789L6.10206 18.4021L4.01242 16.8592C3.74181 16.6594 3.88127 16.2302 4.21759 16.2276L6.81524 16.2075L7.63712 13.7433C7.74356 13.4241 8.19483 13.4241 8.30118 13.7433Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.7341 14.3505L18.3235 15.1543L19.2745 14.8568C19.3977 14.8183 19.4989 14.9587 19.4236 15.0633L18.8413 15.872L19.4181 16.6846C19.4928 16.7898 19.3905 16.9295 19.2677 16.8902L18.3186 16.5864L17.7239 17.3861C17.647 17.4896 17.4824 17.4355 17.482 17.3066L17.4776 16.31L16.5332 15.9916C16.4111 15.9502 16.4115 15.7772 16.5341 15.7368L17.4804 15.4247L17.4915 14.4282C17.4929 14.2994 17.6578 14.2465 17.7341 14.3505Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.1457 11.9552L15.1365 12.0628L15.5591 11.1604C15.6139 11.0436 15.7858 11.0636 15.8121 11.1898L16.0158 12.1652L17.0047 12.2883C17.1327 12.3042 17.1668 12.4739 17.0548 12.5381L16.1901 13.0332L16.3786 14.0117C16.4031 14.1385 16.2522 14.2232 16.1566 14.1366L15.4184 13.4672L14.5461 13.9488C14.4332 14.0112 14.3058 13.8938 14.3587 13.7762L14.7672 12.8672L14.0395 12.1863C13.9453 12.0986 14.0175 11.9413 14.1457 11.9552Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.7119 21.6128L15.1226 22.4165L14.1715 22.119C14.0484 22.0805 13.9471 22.221 14.0225 22.3256L14.6047 23.1343L14.0279 23.9468C13.9532 24.052 14.0555 24.1918 14.1783 24.1524L15.1275 23.8486L15.7221 24.6483C15.799 24.7518 15.9636 24.6977 15.9641 24.5688L15.9685 23.5722L16.9128 23.2538C17.0351 23.2125 17.0345 23.0394 16.9119 22.999L15.9656 22.6869L15.9545 21.6904C15.9529 21.5617 15.7882 21.5087 15.7119 21.6128Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.3001 19.3614L18.3094 19.469L17.8867 18.5666C17.832 18.4498 17.6601 18.4698 17.6337 18.5961L17.4299 19.5715L16.441 19.6945C16.313 19.7104 16.2789 19.8802 16.3909 19.9443L17.2557 20.4395L17.0671 21.418C17.0427 21.5447 17.1936 21.6295 17.2892 21.5429L18.0274 20.8734L18.8996 21.3551C19.0125 21.4175 19.14 21.3001 19.087 21.1824L18.6785 20.2734L19.4063 19.5926C19.5007 19.5049 19.4285 19.3476 19.3001 19.3614Z",
					fill: "#FFE15A"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53074",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCnFlag);
export { ForwardRef as ReactComponent };
